import { styled } from "../../../../styles";

export const SectionWrapper = styled("div", {
  width: "100%",
  marginTop: "24px",
  marginBottom: "36px",
});

export const HeaderContainer = styled("div", {
  display: "flex",
  position: "relative",
  marginBottom: "12px",
});

export const AddTaskButton = styled("div", {
  // EN-5191: was a fixed 90x26 sized around the English label. A longer translation
  // ("Patiënt toevoegen", "Taak toevoegen") overflowed the width and the fixed height
  // clipped the wrapped second line. The minimums leave the English button unchanged.
  width: "max-content",
  minWidth: "90px",
  minHeight: "26px",
  whiteSpace: "nowrap",
  padding: "5px 11px",
  boxSizing: "border-box",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  backgroundColor: "$gray-50",
  borderRadius: "12px",
  color: "$black",

  fontSize: "12px",
  lineHeight: "16px",
  fontFamily: "$openSans",
  fontWeight: "500",

  position: "absolute",
  top: "8px",
  right: "1px",

  cursor: "pointer",

  "&:hover": {
    backgroundColor: "$gray-60",
  },
});

export const TableContainer = styled("div", {
  width: "100%",
  height: "520px",
  minHeight: "520px",
  overflow: "auto",
});

export const TableInnerContainer = styled("div", {
  width: "100%",
  height: "520px",
  minHeight: "520px",
  overflow: "auto",
});

export const EmptyStateContent = styled("div", {
  width: "100%",
  minHeight: "520px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  rowGap: "10px",
  color: "$black",
  backgroundColor: "$white",
  border: "1px solid $gray-40",
  borderRadius: "8px",
  boxSizing: "border-box",
});

export const TagContainer = styled("div", {
  div: {
    position: "inherit",
    height: "26px",
  },
});

export const NoTasksMessage = styled("p", {
  marginTop: "10px",
  width: "418px",
  textAlign: "center",
  fontFamily: "$openSans",
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "21px",
});
